import analytics from 'js/project/common/util/segmentAnalytics';

// services
import * as api from 'js/common/services/api';

// types
import { GroupId } from 'js/common/types/groups';
import { OrganizationId, CreateOrganization } from 'js/common/types/organizations';
import { ClearbitData } from './analyticsUtils';

interface Params {
  orgName?: string;
  isNDS?: boolean;
  signupSource?: string;
  signupMethod?: string;
  isOnPrem?: boolean;
  centralUrl?: string;
  clearbitData?: ClearbitData;
}

export type CreateInitialOrgAndProject = (params: Params) => Promise<{ orgId: OrganizationId; groupId: GroupId }>;

export async function createInitialOrgAndProject({
  orgName,
  isNDS,
  signupSource,
  signupMethod,
  isOnPrem = false,
  centralUrl = '',
  clearbitData = {},
}: Params) {
  const createOrganizationRequestData: CreateOrganization = {
    name: orgName,
    initialGroupType: isOnPrem ? 'ONPREM' : isNDS ? 'NDS' : 'CLOUD',
    centralUrl,
    clearbitData,
  };

  const newOrgResponse = await api.organization.createOrganization(createOrganizationRequestData);
  const orgId = newOrgResponse.id;

  const newGroupResponse = await api.user.addAnotherGroup({
    orgId,
    group: 'Project 0',
    anonymousId: analytics.user()?.anonymousId() ?? null, // ops manager does not have segment enabled
    centralUrl,
    signupSource,
    signupMethod,
  });
  const groupId = newGroupResponse.newObjId;

  return { orgId, groupId, orgName: newOrgResponse.name };
}
